import { render, staticRenderFns } from "./PurchaseListFunc.vue?vue&type=template&id=6f73cabc&scoped=true&"
import script from "./PurchaseListFunc.vue?vue&type=script&lang=js&"
export * from "./PurchaseListFunc.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseListFunc.vue?vue&type=style&index=0&id=6f73cabc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f73cabc",
  null
  
)

export default component.exports